import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutGrid, Film, Mail, Users, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutGrid, end: true },
  { to: "/admin/media", label: "Media", icon: Film },
  { to: "/admin/onboarding", label: "Onboarding", icon: Users },
  { to: "/admin/contacts", label: "Contacts", icon: Mail },
];

export default function AdminLayout() {
  const loc = useLocation();
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-black text-white grid grid-cols-12 grain-overlay" data-testid="admin-layout">
      <aside className="col-span-12 md:col-span-3 lg:col-span-2 border-r border-neutral-900 p-6 flex flex-col">
        <div className="mb-12">
          <div className="font-bodoni text-2xl">JITSUENT</div>
          <div className="font-mono text-[9px] tracking-[0.3em] text-neutral-600">CONTROL ROOM</div>
        </div>

        <nav className="space-y-1 flex-1">
          {NAV.map((n) => {
            const active = n.end ? loc.pathname === n.to : loc.pathname.startsWith(n.to) && n.to !== "/admin";
            const Icon = n.icon;
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`admin-nav-${n.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-3 py-2.5 font-mono text-xs tracking-widest border ${
                  active
                    ? "border-white bg-neutral-950 text-white"
                    : "border-transparent text-neutral-500 hover:text-white hover:border-neutral-800"
                }`}
              >
                <Icon size={14} /> {n.label.toUpperCase()}
              </Link>
            );
          })}
        </nav>

        <div className="border-t border-neutral-900 pt-6 mt-6 space-y-3">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 font-mono text-[10px] text-neutral-500 hover:text-white">
            <ExternalLink size={12} /> VIEW SITE
          </a>
          <div className="font-mono text-[10px] text-neutral-600 break-all">{user?.email}</div>
          <button onClick={handleLogout} data-testid="admin-logout" className="flex items-center gap-2 font-mono text-[10px] text-neutral-500 hover:text-white">
            <LogOut size={12} /> SIGN OUT
          </button>
        </div>
      </aside>

      <main className="col-span-12 md:col-span-9 lg:col-span-10">
        <Outlet />
      </main>
    </div>
  );
}
